import axios from 'axios';

(function () {
  var state = {
    items: [],
    themes: [],
    tags: [],
    query: '',
    selectedThemes: new Set(),
    selectedTags: new Set(),
    expanded: new Set()
  };

  function decodeEntities(s) {
    var el = document.createElement('textarea');
    el.innerHTML = s || '';
    return el.value;
  }

  function visibleItems() {
    var q = state.query.trim().toLowerCase();
    return state.items.filter(function (item) {
      if (q && item.searchText.indexOf(q) === -1) return false;
      if (state.selectedThemes.size && !state.selectedThemes.has(item.theme)) return false;
      var hasAllTags = Array.from(state.selectedTags).every(function (t) {
        return item.tags.indexOf(t) !== -1;
      });
      if (!hasAllTags) return false;
      return true;
    });
  }

  function buildChips(containerId, values, selectedSet, extraClass) {
    var container = document.getElementById(containerId);
    values.forEach(function (value) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'filter-chip' + (extraClass ? ' ' + extraClass : '');
      chip.textContent = decodeEntities(value);
      chip.setAttribute('aria-pressed', 'false');
      chip.addEventListener('click', function () {
        if (selectedSet.has(value)) {
          selectedSet.delete(value);
          chip.setAttribute('aria-pressed', 'false');
        } else {
          selectedSet.add(value);
          chip.setAttribute('aria-pressed', 'true');
        }
        onFiltersChanged();
      });
      container.appendChild(chip);
    });
  }

  function cardHtml(item) {
    var tags = item.tags.map(function (t) {
      return '<span class="govuk-tag lbh-tag lbh-tag--yellow">' + t.toUpperCase() + '</span>';
    }).join('');
    return `<div class="map-item">
      <div class="map-image"> 
        <a data-module="govuk-button" href="${item.link}" target="_blank">
            <img src=${item.image_link} height="200px" width="250px" alt="${decodeEntities(item.title) }">
        </a>
      </div>
      <div class="map-text">
        <div class="title-block">
            <a data-module="govuk-button" href="${item.link}" target="_blank">
                <h3 class="lbh-heading-h3">${decodeEntities(item.title)}</h3>
            </a>
            <a class="link-icon" data-module="govuk-button" href="${item.link}" target="_blank">
                <span><i class="fa-solid fa-up-right-from-square"></i></span>
            </a>
        </div>
            <p class="lbh-body-m">${decodeEntities(item.summary)}</p>
            <div class="tags">${tags}</div>
        </div> 
      </div>`;
  }

  function render() {
    var items = visibleItems();
    var byTheme = {};
    items.forEach(function (item) {
      (byTheme[item.theme] = byTheme[item.theme] || []).push(item);
    });
    var themesWithResults = state.themes.filter(function (t) { return byTheme[t]; });

    var html = '';
    themesWithResults.sort().forEach(function (theme) {
      var isOpen = state.expanded.has(theme);
      html += "<div class='govuk-accordion__section" + (isOpen ? ' govuk-accordion__section--expanded' : '') + "' data-theme=\"" + theme + '">' +
        "<div class='govuk-accordion__section-header'>" +
        "<h5 class='govuk-accordion__section-heading'>" +
        "<button type='button' class='govuk-accordion__section-button' aria-expanded='" + isOpen + "'>" +
        theme + ' (' + byTheme[theme].length + ')' +
        '</button></h5>' +
        "<span class='govuk-accordion__icon' aria-hidden='true'></span>" +
        '</div>' +
        "<div class='govuk-accordion__section-content'>" +
        byTheme[theme].map(cardHtml).join('') +
        '</div></div>';
    });

    var container = document.getElementById('section-accordion-div');
    if (themesWithResults.length) {
      container.innerHTML = "<div class='govuk-accordion myClass lbh-accordion' data-module='govuk-accordion' id='default-example' data-attribute='value'>" + html + '</div>';
    } else {
      container.innerHTML = '<p class="lbh-body no-results">No maps or apps match your search. Try different keywords or clear the filters.</p>';
    }

    container.querySelectorAll('.govuk-accordion__section-header').forEach(function (header) {
      header.addEventListener('click', function () {
        var theme = header.parentElement.getAttribute('data-theme');
        if (state.expanded.has(theme)) {
          state.expanded.delete(theme);
        } else {
          state.expanded.add(theme);
        }
        render();
      });
    });

    var total = state.items.length;
    document.getElementById('results-count').textContent =
      'Showing ' + items.length + ' of ' + total + ' maps and apps' +
      (themesWithResults.length ? ' in ' + themesWithResults.length + ' subject' + (themesWithResults.length === 1 ? '' : 's') : '');

    updateControls(themesWithResults);
  }

  function updateControls(visibleThemes) {
    var openAll = document.getElementById('open-all');
    var closeAll = document.getElementById('close-all');
    var openCount = visibleThemes.filter(function (t) { return state.expanded.has(t); }).length;
    openAll.disabled = visibleThemes.length === 0 || openCount === visibleThemes.length;
    closeAll.disabled = visibleThemes.length === 0 || openCount === 0;
  }

  function currentVisibleThemes() {
    var byTheme = {};
    visibleItems().forEach(function (item) { byTheme[item.theme] = true; });
    return state.themes.filter(function (t) { return byTheme[t]; });
  }

  function onFiltersChanged() {
    if (state.query.trim() || state.selectedThemes.size || state.selectedTags.size) {
      currentVisibleThemes().forEach(function (t) { state.expanded.add(t); });
    }
    render();
  }


  axios.get(`${process.env.GEOSERVER_URL}?service=WFS&version=1.0.0&request=GetFeature&outputFormat=json&typeName=data_repository`)
    .then(function (res) {
      const features = true ? res.data.features : res.data;
      const themes = features.map(function (f) { return f.properties.theme; }).filter(theme => theme !== null);
      const tags = features.flatMap(function (f) { return f.properties.tag || []; });
      const items= features.map(f => f.properties);
      //  console.log('items', items);
    //    items.forEach(item => console.log(JSON.parse(item.json), 'is this logging?'))


    state.themes = Array.from(new Set(themes));
    state.tags = Array.from(new Set(tags.filter(function (t) { return t !== 'Filters'; })));
    state.tags.push("Data Downloads")
    state.items = items
    .filter( (item)=> 
    {   
        const layerIsPublished = item.published === true || item.published.toLowerCase() === 'yes'
         return layerIsPublished; })
    .map(function (item) {
    
          item.title = item.gallery_title;
          item.summary = item.gallery_summary;
          item.tags = (item.tag ? [item.tag] : []).filter(function (t) { return t !== 'Filters'; });
          JSON.parse(item.json)?.layerDownloads? item.tags.push('Data Downloads') : null;
          // console.log(item.tags)
          item.searchText = decodeEntities((item.gallery_title || '') + ' ' + (item.gallery_summary || '')).toLowerCase();
          return item;
        });

      buildChips('subject-chips', state.themes, state.selectedThemes, '');
      buildChips('tag-chips', state.tags, state.selectedTags, 'filter-chip--tag');

      var input = document.getElementById('gallery-search');
      input.addEventListener('input', function () {
        state.query = input.value;
        onFiltersChanged();
      });

      var toggle = document.getElementById('filter-toggle');
      var panel = document.getElementById('filters-panel');
      toggle.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        toggle.textContent = open ? 'Close filters' : 'Open filters';
        toggle.setAttribute('aria-expanded', String(open));
      });

      document.getElementById('clear-filters').addEventListener('click', function () {
        state.selectedThemes.clear();
        state.selectedTags.clear();
        document.querySelectorAll('.filter-chip[aria-pressed="true"]').forEach(function (chip) {
          chip.setAttribute('aria-pressed', 'false');
        });
        onFiltersChanged();
      });

      document.getElementById('open-all').addEventListener('click', function () {
        currentVisibleThemes().forEach(function (t) { state.expanded.add(t); });
        render();
      });
      document.getElementById('close-all').addEventListener('click', function () {
        state.expanded.clear();
        render();
      });

      document.getElementById('loading-text').innerHTML = '';
      render();
    })
    .catch(function (err) {
      console.error(err);
      document.getElementById('loading-text').textContent = 'Sorry, the maps could not be loaded.';
    });
})();
